<template>
  <svg
    v-if="filled"
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.2 13.8119C25.2 19.9605 20.1693 24.9403 13.9699 24.9403C12.0136 24.9403 10.1588 24.4322 8.53275 23.5429L2.33334 25.5501L4.36594 19.5793C3.34964 17.9024 2.76527 15.9207 2.76527 13.8373C2.73986 7.66326 7.77053 2.68341 13.9699 2.68341C20.1693 2.68341 25.2 7.66326 25.2 13.8119ZM19.2264 15.9195C19.3992 16.0107 19.5137 16.0711 19.57 16.1461C19.6423 16.2666 19.6423 16.7729 19.4494 17.3516C19.2324 17.9544 18.1715 18.5331 17.6893 18.5813C17.6085 18.5894 17.5412 18.6056 17.4727 18.6221C17.1325 18.7041 16.7624 18.7932 14.5549 17.9303C12.0572 16.9539 10.4148 14.5022 10.1312 14.0788C10.1137 14.0525 10.1013 14.0341 10.0943 14.0243C10.0887 14.0164 10.0812 14.0062 10.0722 13.9937C9.88776 13.7403 9.03341 12.566 9.03341 11.3479C9.03341 10.1591 9.61774 9.53366 9.8933 9.23873C9.91393 9.21665 9.93284 9.19642 9.94963 9.17795C10.1907 8.93684 10.4801 8.8645 10.6489 8.8645C10.7365 8.8645 10.8306 8.871 10.9211 8.87725C11.0049 8.88304 11.0856 8.88861 11.1552 8.88861C11.1705 8.88861 11.1867 8.8878 11.2036 8.88695C11.3459 8.87978 11.5399 8.87001 11.7339 9.32261C11.7921 9.46511 11.8713 9.66155 11.9574 9.875C12.1916 10.4561 12.4766 11.1633 12.5295 11.2515C12.6019 11.3962 12.6501 11.5408 12.5536 11.7096C12.5272 11.7558 12.5044 11.7985 12.4828 11.8389C12.4253 11.9462 12.3759 12.0386 12.2884 12.1436C12.2522 12.1871 12.2137 12.235 12.1744 12.2839C12.083 12.3977 11.9869 12.5174 11.9026 12.6017C11.758 12.7223 11.6374 12.8669 11.7821 13.1322C11.9267 13.3733 12.4572 14.2413 13.2287 14.9164C14.0937 15.6758 14.8478 15.9923 15.2006 16.1403C15.251 16.1615 15.2932 16.1792 15.3264 16.1943C15.5675 16.3148 15.7363 16.2907 15.881 16.1219C15.8967 16.1036 15.9166 16.0805 15.9399 16.0535C16.1315 15.8314 16.5503 15.3457 16.7007 15.1093C16.8695 14.8682 17.0383 14.8923 17.2794 14.9887C17.4299 15.0489 17.9845 15.3159 18.4445 15.5373C18.7214 15.6705 18.964 15.7873 19.0636 15.8326C19.1227 15.8648 19.1769 15.8934 19.2264 15.9195Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.26527 13.8373L3.26527 13.8352C3.24102 7.94305 8.04255 3.18341 13.9699 3.18341C19.8977 3.18341 24.7 7.94384 24.7 13.8119C24.7 19.6799 19.8977 24.4403 13.9699 24.4403C12.1855 24.4403 10.4888 23.9979 8.98486 23.2173C8.72894 23.0845 8.4249 23.0523 8.13965 23.1446L3.28614 24.716C3.22089 24.7372 3.15948 24.6748 3.18158 24.6099L4.75156 19.9981C4.85552 19.6927 4.81541 19.3649 4.66172 19.0965C3.77301 17.5444 3.26527 15.7351 3.26527 13.8373Z"
      :stroke="color"
    />
    <path
      d="M19.57 16.1461C19.4976 16.0496 19.3289 15.9773 19.0636 15.8326C18.7984 15.7121 17.5205 15.0852 17.2794 14.9887C17.0383 14.8923 16.8695 14.8682 16.7008 15.1093C16.532 15.3745 16.0256 15.9532 15.881 16.1219C15.7363 16.2907 15.5675 16.3148 15.3264 16.1943C15.0612 16.0737 14.2173 15.7844 13.2288 14.9164C12.4572 14.2413 11.9268 13.3733 11.7821 13.1322C11.6374 12.8669 11.758 12.7223 11.9026 12.6017C12.0232 12.4812 12.1679 12.2883 12.2884 12.1436C12.409 11.9989 12.4572 11.8784 12.5536 11.7096C12.6501 11.5408 12.6019 11.3962 12.5295 11.2515C12.4572 11.1309 11.9509 9.85306 11.7339 9.32261C11.5169 8.81628 11.2999 8.88861 11.1552 8.88861C11.0105 8.88861 10.8176 8.8645 10.6489 8.8645C10.4801 8.8645 10.1908 8.93684 9.94964 9.17795C9.70853 9.44317 9.03342 10.0701 9.03342 11.3479C9.03342 12.6258 9.97375 13.8555 10.0943 14.0243C10.2149 14.1931 11.9026 16.8935 14.5549 17.9303C17.2071 18.9671 17.2071 18.6295 17.6893 18.5813C18.1715 18.5331 19.2324 17.9544 19.4494 17.3516C19.6423 16.7729 19.6423 16.2666 19.57 16.1461Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
